import { isFunction } from "../is.js";
function getAllProperties(object, props = [], testFn = null) {
  const proto = Object.getPrototypeOf(object);
  if (proto === Object.prototype || proto === null) {
    return props;
  }
  let foundProps = Object.getOwnPropertyNames(proto);
  if (isFunction(testFn)) {
    foundProps = foundProps.filter((name) => testFn(name, proto));
  }
  foundProps = foundProps.map((name) => [name, proto]).reduce((acc, val) => [...acc, val], props);
  return getAllProperties(proto, foundProps, testFn);
}
export {
  getAllProperties as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
